//Reset data
export const RESET = "SERVICE_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "SERVICE_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SERVICE_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SERVICE_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SERVICE_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "SERVICE_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SERVICE_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SERVICE_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SERVICE_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SERVICE_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "SERVICE_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "SERVICE_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SERVICE_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SERVICE_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SERVICE_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "SERVICE_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "SERVICE_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SERVICE_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SERVICE_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SERVICE_SHOW_SET_MODAL_TYPE"